import { render, staticRenderFns } from "./SeguimientoForm.vue?vue&type=template&id=187e018a"
import script from "./SeguimientoForm.vue?vue&type=script&lang=js"
export * from "./SeguimientoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports